import { ChangeDetectorRef, Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { StepIds } from '../../../models/motors-step/motors-step-model';
import { MotorsDraftFacade, UserFacade } from '@classifieds-sell/state';
import { MotorsSectionBase } from '../../motors-section-base';
import { filter, takeUntil } from 'rxjs/operators';
import { FeeCalculationFacade } from '../../../state/fee-calculation/fee-calculation.facade';
import { getListingPrice } from '../../../helpers/price.helper';
import { SellingTypeEnum } from '@classifieds-sell/datalayer';

@Component({
    selector: 'motors-summary-page-summary-section',
    templateUrl: './summary-page-summary-section.component.html',
    styleUrls: ['./summary-page-summary-section.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SummaryPageSummarySectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;
    memberSummary = this._userFacade.memberSummary$;
    memberBalance: number;
    private _destroyed$: Subject<void> = new Subject<void>();
    listingPrice: number | null;
    packagePrice: number;
    SellingTypeEnum = SellingTypeEnum;

    constructor(
        draftFacade: MotorsDraftFacade,
        private _changeDetectorRef: ChangeDetectorRef,
        private _userFacade: UserFacade,
        private _feeCalculationFacade: FeeCalculationFacade
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.listingPrice = getListingPrice(
              this.categoryId,
              this.draftData
            );

            this._changeDetectorRef.markForCheck();
        });

        this._userFacade.memberSummary$
            .pipe(
                takeUntil(this._destroyed$),
                filter((memberSummary) => !!memberSummary)
            )
            .subscribe((memberSummary) => {
                this.memberBalance = memberSummary.balance;
                this._changeDetectorRef.markForCheck();
            });

        this._feeCalculationFacade.totalFee$
            .pipe(
                takeUntil(this._destroyed$)
            )
            .subscribe((totalFee) => {
                this.packagePrice = totalFee;
                this._changeDetectorRef.markForCheck();
            });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
